export default {
  failed_to_load: 'Failed to load home',
  view_all: 'All >',
  all: 'All',
  continue_play: 'Continue play',
  favorites: 'Favorites',
  page_aria: 'page {n}',
  notifications_aria: 'notifications',
  banner_alt: 'banner',
  slide_aria: 'slide {n}',
  latest_bet_heading: 'Latest bet & Race',
  recent_victory_heading: 'Recent Great Victory',
  no_recent_games: 'No recent games yet',
  no_favorites_yet: 'No favorites yet',

  // === Static scaffolding moved out of the /api/home mock ===

  // Top tab + game-block titles. One key per category — the same string is
  // used for the top tab (when the category appears in the tab strip) and
  // for the matching game-block heading.
  tab_lobby: 'Lobby',
  tab_original: 'Original Games',
  tab_hash: 'Hash Games',
  tab_hot: 'Hot Games',
  tab_slots: 'Slot',
  tab_live: 'Live Casino',
  tab_gameshows: 'Game Shows',
  tab_table: 'Card',
  tab_new: 'New Releases',
  tab_top: 'Top Picks',
  tab_leisure: 'Fishing',
  tab_sport: 'Sports',

  // Quick-entry pill labels under the balance card. TG is a literal.
  qk_agent: 'Agent',
  qk_support: 'Support',

  // Latest-bet table chrome (tabs + column headers).
  lb_all: 'All bets',
  lb_high: 'High Roller',
  col_game: 'Game',
  col_player: 'Player',
  col_multiplier: 'Multiplier',
  col_profit: 'Profit',

  // Recommend section title.
  recommended: 'Recommended',

  // Fallback marquee shown when /api/v1/marquees returns no items.
  default_notice:
    'Staff will never ask you for account info, security password, or verification codes · Verify the official domain · Beware of phishing links',

  pwa_title: 'Add app to home screen',
  pwa_subtitle: 'Faster access, more convenient gaming',
  pwa_step1: 'Click the "More" button at the bottom of your browser.',
  pwa_step2: 'Click the "Share" button',
  pwa_step3: 'Click the "View More" button',
  pwa_add: 'Add',
  pwa_step4: 'Scroll down to find the "Add to Home Screen" button and tap it.',
  pwa_android_step1: 'Click the "More" button at the top of your browser.',
  pwa_android_step2: 'Scroll down to find the "Add to home screen" button and click it.',
  pwa_android_step3: 'Click the "Install" button to add.',
};
